// Copyright (c) 2026 Anchorbase, Inc. All rights reserved.

export const WINDOWS_INSTALLER_PUBLISHED_FILE_NAME = 'Anchorbase App Setup.exe';
export const WINDOWS_INSTALLER_QA_PUBLISHED_FILE_NAME = 'Anchorbase App Setup.json';

export type WindowsArtifactArchitecture = 'x64' | 'arm64';
export type WindowsArtifactTrack = 'stable' | 'latest';
export type WindowsPeRole =
    | 'installer'
    | 'portable'
    | 'main_executable'
    | 'uninstaller'
    | 'bundled';
export type WindowsPeOwner = 'anchorbase' | 'third_party' | 'unknown';
export type WindowsPeSignatureClassification =
    | 'anchorbase_signed'
    | 'trusted_third_party_signed'
    | 'unsigned'
    | 'invalid_or_untrusted';
export type WindowsPeRequiredAction = 'preserve' | 'anchorbase_sign' | 'reject';

export interface WindowsPeQaEvidenceV1 {
    readonly relativePath: string;
    readonly role: WindowsPeRole;
    readonly peKind: 'executable' | 'dll';
    readonly peArchitecture: string;
    readonly companyName: string | null;
    readonly productName: string | null;
    readonly owner: WindowsPeOwner;
    readonly signatureClassification: WindowsPeSignatureClassification;
    readonly signatureStatus: string;
    readonly publisher: string | null;
    readonly signerSubject: string | null;
    readonly signerThumbprint: string | null;
    readonly timestamped: boolean;
    readonly prePackagingSha256: string | null;
    readonly finalSha256: string;
    readonly requiredAction: WindowsPeRequiredAction;
}

export interface WindowsArtifactQaChecksV1 {
    readonly installerSigned: boolean;
    readonly installerTimestamped: boolean;
    readonly installerPublisherMatches: boolean;
    readonly portableSigned: boolean;
    readonly mainExecutableSigned: boolean;
    readonly uninstallerSigned: boolean;
    readonly allPackagedPeFilesSigned: boolean;
}

export interface WindowsArtifactQaV1 {
    readonly schemaVersion: 1;
    readonly result: 'pass' | 'fail';
    readonly artifact: {
        readonly fileName: string;
        readonly publishedFileName: typeof WINDOWS_INSTALLER_PUBLISHED_FILE_NAME;
        readonly qaFileName: string;
        readonly publishedQaFileName: typeof WINDOWS_INSTALLER_QA_PUBLISHED_FILE_NAME;
        readonly architecture: WindowsArtifactArchitecture;
        readonly track: WindowsArtifactTrack;
        readonly version: string;
        readonly buildNumber: string;
        readonly commitId: string;
        readonly installerSha256: string;
    };
    readonly checks: WindowsArtifactQaChecksV1;
    readonly files: readonly WindowsPeQaEvidenceV1[];
}

export type WindowsArtifactQa = WindowsArtifactQaV1;
